import React from 'react';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './CommissionPointsAndPrice.scss';
var CommissionPointsAndPrice = function (_a) {
    var points = _a.points, price = _a.price;
    return (React.createElement("div", { className: s['root'] },
        points && (React.createElement("div", { className: s['points-value'] },
            React.createElement(PointsIcon, { className: s['points-icon'], size: IconSize.SMALLER }),
            points)),
        React.createElement("div", { className: s['dollars-cost'] }, price)));
};
CommissionPointsAndPrice.displayName = 'CommissionPointsAndPrice';
export default CommissionPointsAndPrice;
//# sourceMappingURL=CommissionPointsAndPrice.js.map